import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  DomainTableHeader,
  DomainTableHeaderText,
  DomainTableStyled,
  LoaderWrapper,
} from './DomainsTable.styled'
import { PendingDomainRow } from './PendingDomainRow'
import { ComponentLoader, TableWithPagination } from '@clickcease/cc-client-components-lib'
import useOverallDomainPerformanceStore from 'Features/home/store/overallDomainPerformance'
import { useGetPaginatedDomainsByStatus } from './api/useGetPaginatedDomainsByStatus'
import { usePagination } from 'Hooks/usePagination'
import { paginationLimit } from 'Features/home/components/OverallDomainsPreformance/utils'
import { EmptyTable } from 'Features/home/components/OverallDomainsPreformance/Components/EmptyTable'

type NewPendingDomainTableProps = {
  debouncedSearch: string
}

export const NewPendingDomainsTable = ({ debouncedSearch }: NewPendingDomainTableProps) => {
  const { t } = useTranslation('dashboard')
  const { botMitigationDataIsLoading } = useOverallDomainPerformanceStore()
  const [currentPageState, setCurrentPageState] = useState<number>(1)
  const { data: pendingDomains, isLoading: isDomainsLoading } = useGetPaginatedDomainsByStatus(
    'pending',
    {
      page: currentPageState,
      search: debouncedSearch || '',
      limit: paginationLimit,
    }
  )

  const pageCount = pendingDomains?.data?.metadata?.pageCount
    ? pendingDomains.data.metadata.pageCount
    : 0

  const totalCount = pendingDomains?.data?.metadata?.totalCount
    ? pendingDomains.data.metadata.totalCount
    : 0

  const {
    currentPage,
    onFirstPage: handleFirstPage,
    onLastPage: handleLastPage,
    onNextPage: handleNextPage,
    onPreviousPage: handlePrevPage,
  } = usePagination({
    pageCount: pageCount || 0,
  })

  useEffect(() => {
    setCurrentPageState(currentPage)
  }, [currentPage])

  const columnNames = [
    { label: t('overall_domain_performance.domain'), flex: '1.7 1 0%' },
    { label: t('overall_domain_performance.paid_marketing'), flex: '0.9 1 0%' },
    { label: t('overall_domain_performance.bot_zapping'), flex: '0.9 1 0%' },
    { label: '', flex: '0.5 1 0%' },
  ]

  const body = !isDomainsLoading ? (
    pendingDomains?.data?.domains?.map((row, index) => <PendingDomainRow key={index} data={row} />)
  ) : (
    <EmptyTable isActiveTable={true} isLoading={isDomainsLoading} />
  )
  return (
    <DomainTableStyled>
      {botMitigationDataIsLoading ? (
        <LoaderWrapper css={{ height: '300px' }}>
          <ComponentLoader css={{ position: 'relative' }} />
        </LoaderWrapper>
      ) : (
        <>
          <DomainTableHeader>
            {columnNames.map(({ label, flex }, index) => (
              <DomainTableHeaderText key={index} css={{ flex }}>
                {t(label)}
              </DomainTableHeaderText>
            ))}
          </DomainTableHeader>
          <TableWithPagination
            body={body}
            pageCount={Math.ceil(pageCount)}
            currentPage={currentPage}
            totalItems={totalCount}
            limitPerPage={paginationLimit}
            textOfSelection={''}
            onFirstPage={handleFirstPage}
            onLastPage={handleLastPage}
            onNextPage={handleNextPage}
            onPreviousPage={handlePrevPage}
            wrapperStyle={{ height: '600px' }}
            tableStyle={{ width: '100%' }}
          />
        </>
      )}
    </DomainTableStyled>
  )
}
